import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators'
import Apis from '@/Apis/_'

@Module({ namespaced: true, name: 'AntecipacaoRecebiveisStore' })
export default class AntecipacaoRecebiveisStore extends VuexModule {
  public antecipacoesList: any[] = []
  public pagina: number = 1
  public qtdPorPagina: number = 50
  public totalRegistros: number = 0
  public filterOn: boolean = false
  public filtroSituacao: any = null
  public search: any = null
  public situacoes: any[] = []
  public locaisExecucaoList: any[] = []
  public drawer: boolean = false
  public selectedHospital: any = null
  public solicitadoInicio: any = null
  public solicitadoFim: any = null

  @Mutation
  setDrawer(value: boolean) {
    this.drawer = value
  }

  @Mutation
  setSelectedHospital(value: any) {
    this.selectedHospital = value
  }

  @Mutation
  setSolicitadoInicio(value: string) {
    this.solicitadoInicio = value
  }

  @Mutation
  setSolicitadoFim(value: string) {
    this.solicitadoFim = value
  }

  @Mutation
  setFilterOn(filterOn: boolean) {
    this.filterOn = filterOn
  }

  @Mutation
  setSituacoes(value: any[]) {
    this.situacoes = value
  }

  @Mutation
  setAntecipacoesList(antecipacoesList: any[]) {
    this.antecipacoesList = antecipacoesList
  }

  @Mutation
  setTotalRegistros(totalRegistros: number) {
    this.totalRegistros = totalRegistros
  }

  @Mutation
  setFiltroSituacao(value: any) {
    this.filtroSituacao = value
  }

  @Mutation
  setPagina(value: number) {
    this.pagina = value
  }

  @Mutation
  setSearch(value: string) {
    this.search = value
  }

  @Mutation
  setLocaisExecucaoList(value: any[]) {
    this.locaisExecucaoList = value
  }

  @Mutation
  clearFiltroAvançado() {
    this.filtroSituacao = null
    this.selectedHospital = null
    this.solicitadoInicio = null
    this.solicitadoFim = null
  }

  @Action
  async getAllAntecipacoes() {
    try {
      const params: any = {
        pagina: this.pagina,
        qtdPorPagina: this.qtdPorPagina,
        situacao: this.filtroSituacao,
        empresaMedicaNome: this.search,
        hospital: this.selectedHospital ? this.selectedHospital : null,
        solicitadoInicio: this.solicitadoInicio,
        solicitadoFim: this.solicitadoFim,
      }

      const request = await Apis.RemuneracaoMedica.AntecipacaoRecebiveisApi.getAllAntecipacoes(params)
      if (request.success) {
        this.context.commit('setAntecipacoesList', request.data.itens || [])
        this.context.commit('setTotalRegistros', request.data.totalRegistros)
      }
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async getSituacoes() {
    try {
      const request = await Apis.RemuneracaoMedica.AntecipacaoRecebiveisApi.getSituacoes()
      if (request.success) {
        this.context.commit('setSituacoes', request.data.status || [])
      }
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async getLocaisExecucaoList() {
    try {
      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getLocaisExecucaoList()
      if (request.success) {
        this.context.commit('setLocaisExecucaoList', request.data.itens)
      }
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro ao buscar os locais de execução.' }
    }
  }

  showAntecipacao: boolean = false
  antecipacaoProfissional: any[] = []
  // null quando o backend não conseguiu resolver o contexto de simulação (FIDC inativo,
  // sem taxa vigente, etc) — frontend distingue "indisponível" de "R$ 0,00 disponível".
  valorTotal: number | null = 0
  historicoAntecipacao: any[] = []
  totalAntecipado: number | null = null
  historicoPagina: number = 1
  historicoQtdPorPagina: number = 25
  historicoTotalRegistros: number = 0
  historicoTotalPaginas: number = 1
  fontesPagadorasAntecipacao: any[] = []
  resumoAntecipacaoBackoffice: any[] = []
  showAntecipacaoMock: boolean = false
  podeAntecipar: boolean = false
  documentoProfissional: string = ''
  termoCessaoVigente: { versao: string, texto: string } | null = null

  @Mutation
  setDocumentoProfissional(value: string) {
    this.documentoProfissional = value
  }

  @Mutation
  setShowAntecipacao(value: boolean) {
    this.showAntecipacao = value
  }

  @Mutation
  setShowAntecipacaoMock(value: boolean) {
    this.showAntecipacaoMock = value
  }

  @Mutation
  setAntecipacaoProfissional(value: any[]) {
    this.antecipacaoProfissional = value
  }

  @Mutation
  setValorTotal(value: number | null) {
    this.valorTotal = value
  }

  @Mutation
  setHistoricoAntecipacao(value: any[]) {
    this.historicoAntecipacao = value
  }

  @Mutation
  setTotalAntecipado(value: number | null) {
    this.totalAntecipado = value
  }

  @Mutation
  setHistoricoPagina(value: number) {
    this.historicoPagina = value
  }

  @Mutation
  setHistoricoQtdPorPagina(value: number) {
    this.historicoQtdPorPagina = value
  }

  @Mutation
  setHistoricoTotalRegistros(value: number) {
    this.historicoTotalRegistros = value
  }

  @Mutation
  setHistoricoTotalPaginas(value: number) {
    this.historicoTotalPaginas = value
  }

  @Mutation
  setFontesPagadorasAntecipacao(value: any[]) {
    this.fontesPagadorasAntecipacao = value
  }

  @Mutation
  setResumoAntecipacaoBackoffice(value: any[]) {
    this.resumoAntecipacaoBackoffice = value
  }

  @Mutation
  setPodeAntecipar(value: boolean) {
    this.podeAntecipar = value
  }

  @Mutation
  setTermoCessaoVigente(value: { versao: string, texto: string } | null) {
    this.termoCessaoVigente = value
  }

  @Action
  async getAntecipacaoProfissional() {
    try {
      const request = await Apis.RemuneracaoMedica.AntecipacaoRecebiveisApi.getAntecipacaoProfissional()
      if (request.success && request.data) {
        this.context.commit('setAntecipacaoProfissional', request.data.itens || [])
        const valorTotalBruto = request.data.valorTotal
        const valorTotal = valorTotalBruto === null || valorTotalBruto === undefined
          ? null
          : valorTotalBruto
        this.context.commit('setValorTotal', valorTotal)
        this.context.commit('setPodeAntecipar', true)
      } else {
        this.context.commit('setAntecipacaoProfissional', [])
        this.context.commit('setValorTotal', null)
        this.context.commit('setPodeAntecipar', false)
      }
      return request
    } catch (error) {
      this.context.commit('setAntecipacaoProfissional', [])
      this.context.commit('setValorTotal', null)
      this.context.commit('setPodeAntecipar', false)
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async getHistoricoAntecipacao(filtros?: {
    dataInicio?: string | null
    dataFim?: string | null
    status?: number | string | null
    hospital?: string | null
  }) {
    try {
      const params = {
        ...(filtros || {}),
        pagina: this.historicoPagina,
        qtdPorPagina: this.historicoQtdPorPagina,
      }
      const request = await Apis.RemuneracaoMedica.AntecipacaoRecebiveisApi.getHistoricoAntecipacao(params)
      if (request.success) {
        const { data } = request
        if (Array.isArray(data)) {
          this.context.commit('setHistoricoAntecipacao', data)
          this.context.commit('setTotalAntecipado', null)
          this.context.commit('setHistoricoTotalRegistros', data.length)
          this.context.commit('setHistoricoTotalPaginas', 1)
        } else {
          this.context.commit('setHistoricoAntecipacao', (data && data.itens) || [])
          const total = data && data.totalAntecipado
          this.context.commit('setTotalAntecipado', total === null || total === undefined ? null : total)
          this.context.commit('setHistoricoTotalRegistros', (data && data.totalRegistros) || 0)
          this.context.commit('setHistoricoTotalPaginas', (data && data.totalPaginas) || 1)
          if (data && data.paginaAtual) this.context.commit('setHistoricoPagina', data.paginaAtual)
        }
      }
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async getFontesPagadorasAntecipacao() {
    try {
      const request = await Apis.RemuneracaoMedica.AntecipacaoRecebiveisApi.getFontesPagadorasAntecipacao()
      if (request.success) {
        this.context.commit('setFontesPagadorasAntecipacao', request.data || [])
      }
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async submeterSolicitacao(payload: {
    creditoId: string
    valorSolicitado: number
    taxaId: string
    parametroOperacaoId: string
    termosCessaoVersao: string
  }) {
    try {
      const request = await Apis.RemuneracaoMedica.AntecipacaoRecebiveisApi.submitAntecipacaoProfissional(payload)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro ao enviar a solicitação.' }
    }
  }

  @Action
  async getTermoCessaoVigente() {
    try {
      const request = await Apis.RemuneracaoMedica.AntecipacaoRecebiveisApi.getTermoCessaoVigente()
      if (request.success && request.data) {
        this.context.commit('setTermoCessaoVigente', {
          versao: request.data.versao,
          texto: request.data.texto,
        })
      }
      return request
    } catch (error) {
      return { success: false, message: 'Erro ao carregar termos de cessão.' }
    }
  }

  @Action
  async obterResumoAntecipacaoBackoffice() {
    try {
      const request = await Apis.RemuneracaoMedica.AntecipacaoRecebiveisApi.obterResumoAntecipacaoBackoffice()
      if (request.success) {
        this.context.commit('setResumoAntecipacaoBackoffice', request.data || [])
      }
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async simularAntecipacao(payload: {
    creditoId: string
    valorSolicitado?: number | null
  }) {
    try {
      const request = await Apis.RemuneracaoMedica.AntecipacaoRecebiveisApi.simularAntecipacao({
        creditoId: payload.creditoId,
        valorSolicitado: payload.valorSolicitado,
      })
      return request
    } catch (error) {
      return { success: false, message: 'Erro ao simular a antecipação.' }
    }
  }
}
